import { motion } from "framer-motion";

export function PageBanner({ eyebrow, title, description, image }) {
  return (
    <section className="relative pt-[72px] overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        {image ? (
          <>
            <img src={image} alt="" className="w-full h-full object-cover" loading="eager" />
            <div className="absolute inset-0 bg-gradient-to-b from-near-black/80 via-near-black/60 to-near-black/90" />
          </>
        ) : (
          <div className="w-full h-full bg-near-black" />
        )}
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28">
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.1 }}
          className="font-inter font-light text-xs tracking-[0.25em] uppercase text-solar-orange mb-4"
        >
          {eyebrow}
        </motion.p>
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.15 }}
          data-testid="page-title"
          className="font-inter font-semibold text-4xl md:text-5xl lg:text-6xl tracking-tighter text-white leading-tight max-w-3xl"
        >
          {title}
        </motion.h1>
        {description && (
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.25 }}
            className="font-inter font-normal text-base md:text-lg text-white/60 max-w-xl mt-5 leading-relaxed line-clamp-2"
          >
            {description}
          </motion.p>
        )}
      </div>
    </section>
  );
}
